import {hatcheriesLayer, hatcheriesMeta} from './shellfish/hatcheries';
//import { monitoringRegionGroupLayer, monitorignRegionsMeta } from './shellfish/monitoringRegions';
//import { stateLayer, stateLayerMeta } from './shellfish/states';
/*
import speciesDiseaseHighlights
//, {diseaseOnlyHighlights} 
from './shellfish/species';
*/
import {publicSurveyData, publicSurveyDataFolder} from './shellfish/publicSurvey';
 
import { statesJson } from './stateSpeciesPathoDistro';
//import { ajaxLayers } from '../AjaxExample/ajaxLayerTest';
import { musselWatchLayers } from './shellfish/musselWatch';

export const layerCompilation = [
	//diseaseOnlyHighlights,
	//speciesDiseaseHighlights, 
	statesJson,
	
	{title: 'Public Monitoring Pathogen Data', type: 'group', items: [
		{layerId:'shellfish-psd', type:'layer', item: publicSurveyData, meta: null},
		
		].concat(publicSurveyDataFolder) 
	, description: `Please select a species below to see available pathogens data.`
	},
	{layerId:'shellfish-hatcheries', type: 'layer', item: hatcheriesLayer, meta:hatcheriesMeta},
	musselWatchLayers
	//ajaxLayers,
	//{layerId:'shellfish-monitoring-region', type: 'layer', item: monitoringRegionGroupLayer, meta:monitorignRegionsMeta},
	//{layerId:'shellfish-state', type: 'layer', item: stateLayer, meta:stateLayerMeta},
		
];
	
	